import React from "react";

const Rate = ({ row }) => {
  return <div>{row?.hourlyRate ? row?.hourlyRate?.toFixed(3) : 0}</div>;
};

export default Rate;
